const home = "/";
const droneOperations = "manual/drone-operations";
const basics = "manual/basics";
const forestManagementPlanning = "manual/forest-management-planning";
const actionPlanning = "manual/action-planning";
const advanced = "manual/advanced";
const prerequisites = "manual/prerequisites";
const guides = "guides";
const faq = "faq";
const api = "api";

const references = {
    Drönaroperationer: droneOperations + "#dronaroperationer",
    "Rapid Orthophoto": droneOperations + "#rapid-orthophotos",
    "Rapid Orthophotos": droneOperations + "#rapid-orthophotos",
    "Drone Mission": droneOperations + "#drone-missions",
    "Drone Missions": droneOperations + "#drone-missions",
    "Drone Operations": droneOperations + "#drone-operations",
    "Drone Free Flight": droneOperations + "#drone-free-flight",
    "Free Flight": droneOperations + "#drone-free-flight",
    Quick: droneOperations + "#quick",
    Balanced: droneOperations + "#balanced",
    Pretty: droneOperations + "#pretty",
    Drönaruppdrag: droneOperations + "#dronaruppdrag",
    Drönaruppdraget: droneOperations + "#dronaruppdrag",
    Drönaruppdragets: droneOperations + "#dronaruppdrag",
    Drönaruppdragen: droneOperations + "#dronaruppdrag",
    Snabbortofoto: droneOperations + "#snabbortofoton",
    Snabbortofotos: droneOperations + "#snabbortofoton",
    Snabbortofoton: droneOperations + "#snabbortofoton",
    Snabbortofotot: droneOperations + "#snabbortofoton",
    Snabbortofotots: droneOperations + "#snabbortofoton",
    Snabbortofotona: droneOperations + "#snabbortofoton",
    Snabb: droneOperations + "#snabb",
    Balanserad: droneOperations + "#balanserad",
    Snygg: droneOperations + "#snygg",
    Markföljning: droneOperations + "#markfoljning",
    "Friflygning med drönare": droneOperations + "#friflygning-med-dronare",
    Friflygning: droneOperations + "#friflygning-med-dronare",
    Uppdragsinställningar: droneOperations + "#uppdragsinstallningar",
    Uppdragsparametrar: droneOperations + "#uppdragsinstallningar",
    "Managed Areas": basics + "#managed-areas",
    "Managed Area": basics + "#managed-areas",
    Geometriredigeraren: basics + "#geometriredigeraren",
    Geometriredigerarens: basics + "#geometriredigeraren",
    "Geometry Editor": basics + "#the-geometry-editor",
    Områden: basics + "#omraden",
    Område: basics + "#omraden",
    Området: basics + "#omraden",
    Spårlogg: basics + "#sparloggar",
    Spårloggen: basics + "#sparloggar",
    Spårloggar: basics + "#sparloggar",
    Tracklog: basics + "#tracklogs",
    Tracklogs: basics + "#tracklogs",
    Arbetsgrupp: basics + "#arbetsgrupper",
    Arbetsgrupper: basics + "#arbetsgrupper",
    Arbetsgruppen: basics + "#arbetsgrupper",
    "Mina arbetsgrupper": basics + "#mina-arbetsgrupper",
    Teams: basics + "#teams",
    Team: basics + "#teams",
    "My Teams": basics + "#my-teams",
    "Offline Availability": basics + "#offline-availability",
    "Terrain Tracking": droneOperations + "#terrain-tracking",
    Project: basics + "#projects",
    Projects: basics + "#projects",
    Projekt: basics + "#projekt",
    Projektet: basics + "#projekt",
    Projektets: basics + "#projekt",
    Projekten: basics + "#projekt",
    "Point Observations": basics + "#observations",
    "Point Observation": basics + "#observations",
    "Area Observations": basics + "#observations",
    "Area Observation": basics + "#observations",
    Observationer: basics + "#observationer",
    Observation: basics + "#observationer",
    Observationen: basics + "#observationer",
    Observationerna: basics + "#observationer",
    Punktobservationer: basics + "#observationer",
    Punktobservation: basics + "#observationer",
    Punktobservationen: basics + "#observationer",
    Punktobservationerna: basics + "#observationer",
    Ytobservationer: basics + "#observationer",
    Ytobservation: basics + "#observationer",
    Observations: basics + "#observations",
    "Map Bundles": basics + "#map-bundles",
    "Map Bundle": basics + "#map-bundles",
    "synkas det nya Snabbortofotot automatiskt och blir tillgängligt för andra användare":
        basics + "#synkronisering-av-projektdata",
    "automatically synced and will become available to other users":
        basics + "#syncing-your-project-data",
    "Tillgänglighet offline": basics + "#tillganglighet-offline",
    "tillgängligt offline": basics + "#tillganglighet-offline",
    "tillgängliga offline": basics + "#tillganglighet-offline",
    "available offline": basics + "#offline-availability",
    Kartan: basics + "#kartan",
    Karta: basics + "#kartan",
    Kartpaket: basics + "#kartpaket",
    Kartpaketet: basics + "#kartpaket",
    "Exportera Snabbortofoton som GeoPackage":
        advanced + "#exportera-snabbortofoton-som-geopackage",
    "Exporting Rapid Orthophotos as GeoPackage":
        advanced + "#exporting-rapid-orthophotos-as-geopackage",
    "Strategic surveying campaigns": guides + "#strategic-surveying-campaigns",
    "Drone Mission Parameters": droneOperations + "#drone-mission-parameters",
    "Strategiska inventeringskampanjer":
        guides + "#strategiska-inventeringskampanjer",
    "Report Error-function": basics + "#errors-and-support",
    felrapporteringsfunktionen: basics + "#fel-och-support",
    "Taktisk användning av drönare": guides + "#taktisk-anvandning-av-dronare",
    "Stöd för planläggare": guides + "#planlaggning",
    "Tactical use of drones": guides + "#tactical-use-of-drones",
    "Support for planners":
        guides + "#creating-and-updating-forest-management-plans",
    "Skapa Snabbortofoton manuellt genom att dra-och-släppa bilder i ett Projekt":
        advanced +
        "#skapa-snabbortofoton-manuellt-genom-att-dra-och-slappa-bilder-i-ett-projekt",
    "Creating Rapid Orthophotos Manually by Importing Images into a Project using Drag-and-Drop":
        advanced +
        "#creating-rapid-orthophotos-manually-by-importing-images-into-a-project-using-drag-and-drop",
    "Create Rapid Orthophotos Manually by Importing Images into a Project using Drag-and-Drop":
        advanced +
        "#creating-rapid-orthophotos-manually-by-importing-images-into-a-project-using-drag-and-drop",
    "Forest Management Planning":
        forestManagementPlanning + "#forest-management-planning",
    "Forest Management Planning Project":
        forestManagementPlanning +
        "#creating-forest-management-planning-projects",
    "Forest Management Planning Projects":
        forestManagementPlanning +
        "#creating-forest-management-planning-projects",
    Planuppdatering: forestManagementPlanning + "#planuppdatering",
    Planuppdateringen: forestManagementPlanning + "#planuppdatering",
    "Planuppdateringen avslutas":
        forestManagementPlanning + "#avsluta-en-planuppdatering",
    "Completing a Forest Management Planning Project":
        forestManagementPlanning +
        "#completing-a-forest-management-planning-project",
    Åtgärder: basics + "#atgarder",
    "Föreslagna åtgärder": basics + "#foreslagna-atgarder",
    "Genomförda åtgärder": basics + "#genomforda-atgarder",
    Åtgärd: basics + "#atgarder",
    Åtgärden: basics + "#atgarder",
    Åtgärderna: basics + "#atgarder",
    Avdelning: basics + "#avdelningar",
    Avdelningar: basics + "#avdelningar",
    Avdelningens: basics + "#avdelningar",
    Avdelnings: basics + "#avdelningar",
    Avdelningen: basics + "#avdelningar",
    "Uppdatera avdelningar":
        forestManagementPlanning + "#uppdatera-avdelningsgeometri",
    "Dela avdelningen": forestManagementPlanning + "#dela-avdelningar",
    "Slå ihop avdelningen": forestManagementPlanning + "#sla-ihop-avdelningar",
    "Updating Compartments":
        forestManagementPlanning + "#update-compartment-geometry",
    Compartments: basics + "#compartments",
    Compartment: basics + "#compartments",
    "Importera Forestand-fil": basics + "#importera-forestand-fil",
    "Importing Forestand File": basics + "#importing-forestand-file",
    Uppgift: basics + "#uppgifter",
    Task: basics + "#tasks",
    Tasks: basics + "#tasks",
    Uppgiften: basics + "#uppgifter",
    Huvudmenyn: basics + "#huvudmenyn",
    "Main Menu": basics + "#the-main-menu",
    "the Main Menu": basics + "#the-main-menu",
    "splitting the Compartment":
        forestManagementPlanning + "#splitting-compartments",
    "Splitting Compartments":
        forestManagementPlanning + "#splitting-compartments",
    "merging the Compartment":
        forestManagementPlanning + "#merging-compartments",
    "Merging Compartments": forestManagementPlanning + "#merging-compartments",
    "Compartment Attributes": basics + "#compartment-attributes",
    Action: basics + "#actions",
    Actions: basics + "#actions",
    Avdelningsattribut: basics + "#avdelningsattribut",
    Avdelningarna: basics + "#avdelningar",
    "Accessing Data via WMS Service":
        advanced + "#accessing-data-via-wms-service",
    "Tillgång till data via WMS-tjänst":
        advanced + "#tillgang-till-data-via-wms-tjanst",
    "Project Type": basics + "#project-types",
    "Project Types": basics + "#project-types",
    "Creating Projects": basics + "#creating-projects",
    "Skapa Projekt": basics + "#skapa-projekt",
    Projekttyp: basics + "#projekttyper",
    Projekttyper: basics + "#projekttyper",
    Budget: actionPlanning + "#budget",
    Budgeten: actionPlanning + "#budget",
    Åtgärdsobjekt: actionPlanning + "#atgardsobjekt",
    Åtgärdsobjektet: actionPlanning + "#atgardsobjekt",
    Åtgärdsobjektets: actionPlanning + "#atgardsobjekt",
    Trakt: actionPlanning + "#trakter",
    Trakterna: actionPlanning + "#trakter",
    Trakter: actionPlanning + "#trakter",
    Trakten: actionPlanning + "#trakter",
    Traktens: actionPlanning + "#trakter",
    Traktgrupp: actionPlanning + "#traktgrupper",
    Traktgrupper: actionPlanning + "#traktgrupper",
    Traktgrupps: actionPlanning + "#traktgrupper",
    Traktgruppens: actionPlanning + "#traktgrupper",
    Åtgärdskedja: basics + "#atgardskedjor",
    Åtgärdskedjor: basics + "#atgardskedjor",
    Åtgärdskedjan: basics + "#atgardskedjor",
    "Action Sequence": basics + "#action-sequences",
    "Action Object": actionPlanning + "#action-objects",
    "Action Objects": actionPlanning + "#action-objects",
    Object: actionPlanning + "#objects",
    Objects: actionPlanning + "#objects",
    Group: actionPlanning + "#groups",
    Groups: actionPlanning + "#groups",
    "Avsluta Projekt": basics + "#avsluta-projekt",
    "Avsluta Projektet": basics + "#avsluta-projekt",
    "Föreslagna Åtgärder": basics + "#foreslagna-atgarder",
    "Lägg till dem i Projektet":
        actionPlanning + "#lagga-till-foreslagna-atgarder-i-atgardsunderlag",
    Åtgärdsunderlag: actionPlanning + "#atgardsunderlag",
    Åtgärdsförslag: actionPlanning + "#skapa-ett-atgardsforslag",
    Åtgärdsförslaget: actionPlanning + "#skapa-ett-atgardsforslag",
    "Lägga till och ta bort Åtgärder":
        forestManagementPlanning + "#lagga-till-och-ta-bort-atgarder",
    "the Detail Panel": basics + "#the-detail-panel",
    "Detail Panel": basics + "#the-detail-panel",
    "the Map": basics + "#the-map",
    "The Map": basics + "#the-map",
    "Completed Actions": basics + "#completed-actions",
    "Completing Projects": basics + "#completing-projects",
    "More-menu": basics + "#the-more-menu",
    "Action Plan": actionPlanning + "#action-planning",
    "Action Proposal": actionPlanning + "#generating-an-action-proposal",
    "Add them to the Project":
        actionPlanning + "#adding-proposed-actions-to-action-plans",
    "Proposed Actions": basics + "#proposed-actions",
    "Proposed Action": basics + "#proposed-actions",
    "Adding and Removing Actions":
        forestManagementPlanning + "#adding-and-removing-actions",
    "Complete the Project": basics + "#completing-projects",
    "Mer-meny": basics + "#mer-menyn",
    "Mer-menyn": basics + "#mer-menyn",
    Detaljpanelen: basics + "#detaljpanelen",
    Detaljpanel: basics + "#detaljpanelen",
    "Genomförda Åtgärder": basics + "#genomforda-atgarder",
    "Beslutade Åtgärder": basics + "#beslutade-atgarder",
    "Decided Actions": basics + "#decided-actions",
    "Lägga till Föreslagna Åtgärder i Åtgärdsunderlag":
        actionPlanning + "#lagga-till-foreslagna-atgarder-i-atgardsunderlag",
    "Adding Proposed Actions to Action Plans":
        actionPlanning + "#adding-proposed-actions-to-action-plans",
    "Lägga till nya Åtgärder i Åtgärdsunderlag":
        actionPlanning + "#lagga-till-nya-atgarder-i-atgardsunderlag",
    "Adding New Actions to Action Plans":
        actionPlanning + "#adding-new-actions-to-action-plans",
    "Enterprise Drones": droneOperations + "#enterprise-drones",
    "Enterprise Drone": droneOperations + "#enterprise-drones",
    "Older Drones": droneOperations + "#older-drones",
    "Enterprise-drönare": droneOperations + "#enterprise-dronare",
    "Äldre drönare": droneOperations + "#aldre-dronare",
    "Laser Range Finder-läget": droneOperations + "#laser-range-finder-laget",
    "Laser Range Finder Mode": droneOperations + "#laser-range-finder-mode",
    "Skapa Observationer från ett Snabbortofotos bildvisare":
        basics + "#fran-ett-snabbortofotos-bildvisare",
    "Creating Observations from a Rapid Orthophoto Image Viewer":
        basics + "#from-a-rapid-orthophoto-image-viewer",
    "our own Forest Management Module": home + "#forest-management",
    "vårt egna förvaltningstöd": home + "#forest-management",
    "Läs mer om hur man praktiskt inventerar skador med Global Forester och drönare":
        guides + "#inventera-skador",
    "Learn how to detect damage with Global Forester and drones":
        guides + "#damage-inventory",
    "Läs mer om hur man praktiskt gör för- och efterkontroller vid avverkning med Global Forester och drönare":
        guides + "#for--och-efterkontroll-vid-avverkning",
    "Learn how to conduct pre- and post-inspections during felling operations using Global Forester and drones":
        guides + "#pre--and-post-harvest-inspection",
    "Läs mer om hur man praktiskt effektiviserar planläggningen med Global Forester och drönare":
        guides + "#effektivare-planlaggning",
    "Learn how to streamline planning with Global Forester and drones":
        guides + "#more-efficient-forest-management-planning",
    "Läs mer om hur man praktiskt använder Global Forester och drönare vid skogsbränder och naturvårdsbränningar":
        guides + "#skogsbrand-och-naturvardsbranning",
    "Learn how to use Global Forester and drones during wildfires and prescribed burnings":
        guides + "#wildfire-and-prescribed-burning",
    "Läs mer om hur man praktiskt inventerar vilt med Global Forester och drönare":
        guides + "#inventera-vilt",
    "Learn how to detect wildlife using Global Forester and drones":
        guides + "#wildlife-inventory",
    Uppgifter: basics + "#uppgifter",
    Planuppdateringsprojekt: forestManagementPlanning + "#planuppdatering",
    Planuppdateringsprojektet: forestManagementPlanning + "#planuppdatering",
    "Dela Avdelningar": forestManagementPlanning + "#dela-avdelningar",
    "Slå ihop Avdelningar": forestManagementPlanning + "#sla-ihop-avdelningar",
    "Importing Photos as Points": advanced + "#importing-photos-as-points",
    "Importera foton som punkter": advanced + "#importera-foton-som-punkter",
    // The former umbrella terms point at the first of the groups that replaced them.
    Factor: basics + "#considerations",
    Factors: basics + "#considerations",
    Karttecken: basics + "#hansyn",
    Hänsyn: basics + "#hansyn",
    Infrastruktur: basics + "#infrastruktur",
    Considerations: basics + "#considerations",
    Infrastructure: basics + "#infrastructure",
    "Äldre drönare med begränsat stöd":
        prerequisites + "#aldre-dronare-med-begransat-stod",
    "Older Drones with Limited Support":
        prerequisites + "#older-drones-with-limited-support",
};

export function getHREF(key, location) {
    if (references[key]) {
        let baseLocation = location.split("/")[1];
        if (baseLocation === "manual") {
            return references[key].split("/")[1];
        } else {
            return references[key];
        }
    } else {
        console.debug("Missing reference for key: ", key, "in", location);
    }
}
